import React from 'react'
import SimplePage from '../layouts/simplePage'

const BookingCondition = () => {
    return (
        <SimplePage
            title={'BOOKING CONDITIONS'}
            image={require('../assets/images/carlous-img3.jpg')}
        >
            <div>
                <div className='contentWrapper'>
                    <div className='content'>
                        <h>
                            India is the seventh largest country in the world.
                            The country's official name, India is derived from
                            the Old Persian version of Sindhu, the historic
                            local appellation for the river Indus.<p></p>
                        </h>
                    </div>
                </div>
                Your contract is with Skyway International Travels, Unit of
                Vagjiani Travel Co Pvt Ltd, India, having website as
                www.skywaytour.com. Please check to ensure that everything you
                booked, viz., packages, flights, hotels and other services are
                confirmed before leaving your home.
                <br />
                <br />
                <strong>1. How to Book </strong>
                <br />
                After choosing your holiday and reading the booking conditions
                please complete the booking form and send it to us along with
                the appropriate non-refundable deposit.
                <br />
                <br />
                Skywaytour.com will send you a booking acceptance letter / mail
                within 5 days of receiving the booking. When you place your
                order with us, it is deemed that you accept our booking
                conditions.
                <br />
                <br />
                <strong>2. Deposit for Tailor-made holidays </strong>
                <br />
                Deposit payable when placing your order is Rs.20,000/- per
                person. A higher deposit may be payable if booking a luxury
                train or high end tour. Some hotels, including beach resorts,
                wildlife lodges and even city hotels during peak season require
                full payment immediately on booking. In such cases a higher
                deposit may be required. We will advise you of these higher
                deposits, if required, while accepting your booking or soon
                after that as many resorts advise us of their advance
                requirements only after a booking has been made with them.
                Please note the deposit amount is non-refundable, except in
                instances when we cancel the holiday or express our inability to
                confirm your booking.
                <br />
                <br />
                <strong>3. Insurance </strong>
                <br />
                It is a condition of your booking with us that you have adequate
                travel insurance or provide us with an indemnity.
                <br />
                <br />
                <strong>4. Confirmation and Final Payment </strong>
                <br />
                On receipt of the booking form and deposit if the holiday
                requested is available, we will send you a Booking Acceptance
                Letter, normally within 7 days. The balance amount due must be
                paid no later than 2 months before departure otherwise we
                reserve the right to treat your booking as cancelled and retain
                the deposit. If the booking is made within 2 months of
                departure, then the full cost of the holiday is payable at the
                time of booking.
                <br />
                <br />
                We do our best to confirm all the arrangements within 7 days
                receiving the order, in some instances changes may be required
                or some confirmations may have to wait till much later. If we
                need to make a significant change to the itinerary booked, such
                as a change of hotel or mode of transport or omission of a
                place, it is done with your concurrence. It is thus important
                that you give us your contact telephone numbers, both for
                daytime and evenings, so that changes to your itinerary, if any,
                can be discussed. For minor variations in the itinerary we do
                not make supplementary charges nor do we offer reductions. If
                however the cost variation exceeds 5% of the total holiday
                price, you may be required to pay the difference, if the costs
                go up, or become entitled to a refund, if the costs go down.
                <br />
                <br />
                We expect you to mention any critical elements, viz., particular
                hotels, resorts, etc., at the time of processing the booking
                itself, changes cannot be made after the booking is processed
                and confirm. In instances where you have not specified any
                critical elements, if the very nature of the holiday changes due
                to non-availability of significant portion(s) of the tour, we
                will ourselves offer you the option of a later departure or
                cancellation with full refund.
                <br />
                <br />
                <strong>5. Travel Documents </strong>
                <br />
                Travel documents are normally sent to you approximately 15 days
                before departure. These may include your international flight
                tickets if issued by us in India, final itinerary, hotel
                vouchers, local contacts at your destination, some useful tips
                including tipping, etc. , Sometimes, vouchers for hotels and
                internal travel, etc., are delivered on arrival at the
                destination by our representatives in India.
                <br />
                <br />
                <strong>6. Price Guarantee </strong>
                <br />
                Tour cost of your holiday is fully guaranteed and is not subject
                to any surcharges. This guarantee is applicable once we have
                accepted your booking through a Booking Acceptance form / email
                and is subject to all payments being received by the due dates.
                The price guarantee applies to complete holidays bought from us
                and does not cover the purchase of individual items such as
                airline tickets or hotel rooms, etc., We always quote flight /
                train charges separately, thus if a flight is quoted separately,
                it is not protected against future cost increases prior to
                ticketing. Also charges for changes, if any supplements for
                upgrade, luggage charges, excess baggage charges, higher grade
                rooms in hotels are not covered by this guarantee.
                <br />
                <br />
                It may be noted that price variations due to changes in
                itinerary are not surcharges and are not governed by this
                guarantee. Surcharge, as defined, is only attributable to
                variation in costs of existing elements of the itinerary.
                <br />
                <br />
                <strong>7. Alteration or Cancellation by you </strong>
                <br />
                You wish to alter your programme after the booking has been
                accepted, for reasons other than non-availability of the portion
                sought to be altered, an amendment fee of Rs.5,000/- per set of
                alterations per person will be charged, in addition to the cost
                increase caused by the alterations. Any requests for alteration,
                once the tour has begun, will be treated sympathetically but we
                cannot guarantee their implementation. Any costs incurred in
                making such alterations, by us or our India office, will be
                passed on to you and the unutilised portion of the holiday will
                attract 100% cancellation charges. Should you wish to cancel
                your tour, you must notify us in writing stating the reasons for
                cancellation as you may be covered by your insurance policy.
                Such cancellation will deem to take place only on the date of
                receipt of your written request and will attract the following
                cancellation charges:
                <strong>Date of receipt of cancellation notification</strong>
                <br />
                Cancellation charges <br />
                More than 60 days before departure - The deposit amount <br />
                29 to 59 days before departure - 50% of tour price
                <br />
                15 to 28 days before departure - 75% of tour price <br />
                14 days before to date of departure or after - 100% of tour
                Price
                <br />
                <br />
                <strong>
                    8. Cancellation of a Tour by us before departure{' '}
                </strong>
                <br />
                We reserve the right to cancel a holiday on offer by us,
                including tailor-made holidays, without assigning reasons at any
                time over 2 months before departure date. If such cancellation
                takes place, we will offer you a comparable alternative or at
                your option refund all monies paid by you. If a holiday
                cancellation takes place within 60 weeks of departure it will be
                for one of the following reasons:
                <ul>
                    <li>
                        Due to non-payment or late payment of the balance amount
                        due. In such cases an alternative holiday or refund will
                        not be available and cancellation charges will apply.
                    </li>
                    <li>
                        Due to circumstances beyond our control such as
                        cancellation of international or domestic scheduled
                        service, technical problems with transportation, civil
                        disorder or the threat of such, riots, strikes, natural
                        disasters, accident or pollution, terrorist activity or
                        the threat of such, war or the threat of war, etc. In
                        deciding whether it is safe to visit a certain
                        destination or not, we depend on the advice of the each
                        Govt. bodies. In such instances we may offer comparable
                        alternative arrangements or if you choose make a full
                        refund of all monies paid.
                    </li>
                    <li>
                        Due to non-availability of significant portions of a
                        private itinerary. In such instances we may offer
                        comparable alternative arrangements or at your option
                        make a full refund of all monies paid except in cases
                        where the booking is made within 2 months of departure.
                        In the unlikely event of us cancelling a holiday within
                        2 months of departure for reasons other than those
                        listed above, we will offer you a compensation of
                        Rs.5,000/- per person and if such cancellation is within
                        14 days of departure then a higher amount of Rs.7,500/-
                        per person.
                    </li>
                </ul>
                <strong>9. Alterations to your tour Programme by us </strong>
                <br />
                We will make all reasonable efforts to provide you with the
                booked tour arrangements but cannot rule out occasional minor
                changes. If the changes are significant we will inform you of
                these before departure, if possible, and offer you comparable
                alternative arrangementsor at your option make a full refund of
                all monies paid. A significant change is one that involves a
                change of airport for international flights to and from your
                holiday destination, the outward or return journey being
                rescheduled by more than twelve hours or the omission of a
                featured overnight stop in the itinerary. Where such changes
                take place for reasons within our control we will offer you a
                compensation of Rs.2,500/- per person if you had paid the full
                holiday price by the prescribed date.
                <br />
                <br />
                Where the change is due to circumstances beyond our control
                amounting to force majeure, such as weather conditions,
                technical problems, civil disorder, decisions by governments or
                other associations, etc., we will offer comparable alternative
                arrangements or if you choose refund fully the monies paid by
                you. If any of the circumstances amounting to force majeure
                occurs during a tour we reserve the right to alter the tour
                programme, as required depending upon the circumstance, without
                offering any compensation. We may consider a refund for the
                unutilised portion of the tour if we are able to obtain any.
                <br />
                <br />
                We reserve the right to cancel your holiday anytime during its
                operation if you are found to be behaving in a socially
                unacceptable manner or indulging in an illegal activity. In such
                cases no refund will be offered for the unutilised portion of
                the holiday and Skyway tour.com will further claim from you the
                costs of your return to the parent country.
                <br />
                <br />
                <strong>10. Your responsibility </strong>
                <br />
                We advise you to plan to obtain, your visa, insurance and health
                requirements yourself. You are responsible for your passports,
                visas, vaccinations, insurance, foreign exchange for personal
                expenses, etc., and we do not accept any liability for
                non-communication of relevant details to you. If any service
                offered by us is not clear, you should get written confirmation
                from us about its inclusion in the price.
                <br />
                <br />
                <strong>11. Our responsibility </strong>
                <br />
                We accept responsibility for ensuring that the holiday which you
                book with us is supplied as described in this website or our
                brochure, or any other literature printed by us, and the
                services offered reach a reasonable standard. In the unlikely
                event that any part is not provided as promised, for reasons
                within our control, we will pay you appropriate compensation if
                this has affected the enjoyment of your holiday. We accept
                responsibility for the acts and/or omissions of our employees,
                agents and suppliers except where they lead to death, injury or
                illness and except where the supplier is a government or
                quasi-government institution. Our liability in all cases shall
                be limited to a maximum of two times the cost of the portion of
                holiday adversely affected.
                <br />
                <br />
                We accept responsibility for death, injury or illness caused by
                the negligent acts and/or omissions of our employees or agents
                together with our suppliers, servants and/or agents of the same
                whilst acting within the scope of, or in the course of their
                employment in the provision of your holiday. We will accordingly
                pay to our clients such damages as might have been awarded in
                such circumstances under Indian Law. We are insured for Errors
                and Omission for this purpose only which a special insurance for
                Tour Operator in India. In respect of carriage by scheduled air,
                sea, other water bodies like rivers and lakes, and rail
                transports the provision of accommodation and services in these
                are the responsibility of the providers of these transports and
                we merely act as agents for these providers. Our liability in
                all such cases will be limited in the manner provided by the
                relevant international convention. Thus if a scheduled flight or
                train or ship has delays or changes in schedule or cancellation
                of service we are not obliged to offer alternative arrangements,
                it is the providers of these services who are responsible. We
                will, however, try our best to assist in the provision of
                alternative services, if required, on receipt of appropriate
                payment for these.
                <br />
                <br />
                If any client suffers death, illness or injury whilst overseas
                arising out of an activity which does not form part of the
                foreign inclusive holiday arrangement or excursion arranged
                through us, we shall, at our discretion, offer advice, guidance
                and assistance but are not liable for the consequences of such
                independent act. If you avail of a service during the course of
                your holiday which is not part of your contract with us, we are
                not liable for the provision of that service or its quality. If
                we recommend a restaurant or a shop or any reading material or
                any other establishment it is to assist you, and often at your
                request, and we do not accept any responsibility for the quality
                or content of the service received from these.
                <br />
                <br />
                <strong>
                    12. Inclusions and exclusions in the Tour Price{' '}
                </strong>
                <br />
                For tailor-made holidays these are clearly spelt out with your
                holiday itinerary.
                <br />
                <br />
                <strong>13. Arbitration </strong>
                <br />
                If you have cause for complaint during the holiday please bring
                it to the notice of our Representative in India /Agent and/or
                the hotel who will try their best to solve the problem. It is
                not advisable to do nothing about a problem when it occurs but
                to later write to us seeking recompense. If we feel you avoided
                action to redress a problem when it occurred, no compensation
                will be offered if it is brought to our attention later. If the
                problem remains unresolved in spite of your pointing it out
                locally to our agents when it occurred please write to us within
                15 days of the completion of the holiday. We shall come back to
                you after investigation within 15 days with suitable answer or
                compensate you nominally which you need to accept.
                <br />
                <br />
                <strong>14. Data Protection Statement </strong>
                <br />
                Please be assured that we have measures in place to protect the
                personal booking information held by us. This information will
                be passed on to the relevant suppliers of your travel
                arrangements. The information may also be provided to public
                authorities such as customs or immigration if required by them,
                or as required by law. Certain information may also be passed on
                to security or credit checking companies. Since your travel is
                outside your area, controls on data protection may not be as
                strong as the legal requirements in your country. If we cannot
                pass this information to the relevant suppliers, we will be
                unable to provide your booking. In making this booking, you
                consent to this information being passed on to the relevant
                persons. If we need to give your details to anyone other than
                those listed above we will do so only with your consent.
                <br />
                <br />
                <strong>15. Jurisdiction </strong>
                <br />
                Your holiday contract with us is made on the terms of these
                Booking Conditions which are governed by Indian Law and both
                parties shall submit to the jurisdiction of Indian Courts in
                Mysore at all times.
                <br />
                <br />
                <strong>16. Validity </strong>
                <br />
                The prices given in our website as stated, with seasonal
                variations, and are subject to the price guarantee mentioned
                earlier. If you wish to travel after this date, we will be happy
                to provide you with a quotation.
            </div>
        </SimplePage>
    )
}

export default BookingCondition
